import {AuthModel, CheckTokenModel, UserModel} from './_models'
import {Http} from '../../../helpers/http'

export const LOGIN_URL = `auth`
export const CHECK_TOKEN = `check_token`
export const GET_USER_BY_ACCESSTOKEN_URL = `get_session_data`
export const SET_LANGUAGE_URL = `set_language`
export const SET_APPLICATION_URL = `set_application`
export const SET_DEALER_URL = `set_dealer`

// Server should return AuthModel
export function login(login: string, password: string) {
  return Http.post<AuthModel>(LOGIN_URL, {
    login,
    password,
  })
}

export function getUserByToken() {
  return Http.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}

export function checkAuthToken() {
  return Http.get<CheckTokenModel>(CHECK_TOKEN)
}

export function setUserLanguageId(language_id: string | number) {
  return Http.post(SET_LANGUAGE_URL, {
    language_id,
  })
}

export function setUserApplicationId(application_id: string | number) {
  return Http.post(SET_APPLICATION_URL, {
    application_id,
  })
}

export function setUserDealerId(dealer_id: string | number) {
  return Http.post(SET_DEALER_URL, {
    dealer_id,
  })
}
